import React, { useState } from "react";
import Webcam from "react-webcam";
import QrReader from "react-web-qr-reader";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import './Qr.css';

import { IconButton, Box, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import logger from "../../Utils/logger";







const QRModal = ({ videoConstraints, cameraFacingMode = "environment" ,qrModelflag,CloseQrFun,fetchMachineByUUID}) => {
  const navigate = useNavigate();
  const [cameraError, setCameraError] = useState(false);
  const [showScanner, setShowScanner] = useState(true);
      const handleBack=()=>{
        CloseQrFun()
    }

  const HeaderSecondary = () => {
  return (
    <Box
      sx={{
        height: 60,
        display: 'flex',
        alignItems: 'center',
        backgroundColor: '#fae14b', // Replace with your theme color
        px: 2,
        position:"fixed",
        zIndex:99999,
        width:"100%"
      }}
    >
      <IconButton sx={{ mr: 1 }} onClick={(e)=>{handleBack()}}>
        <CloseIcon fontSize="medium" />
      </IconButton>
      <Typography
        variant="subtitle1"
        sx={{ fontWeight: 500, color: '#333', mt: 0.5 }}
      >
        Scan QR Code
      </Typography>
    </Box>
  );
};

  const handleError = (err) => {
    //logger.error(err);
    setCameraError(true);
  };

  const handleScan = (result) => {
    logger.log("QR Scan Result:", result.data); 
    
    const url = result.data;
const params = new URLSearchParams(new URL(url).search);

const uuidValue = params.get("value");
logger.log("uuidValue==null",uuidValue=="null",uuidValue); // "3WE9GL"

if(!(uuidValue=="null"))
  if(uuidValue){
  {
    fetchMachineByUUID(uuidValue);
     CloseQrFun()
    return null
  }}

if (result?.data) {
  try {
    const url = new URL(result.data);
    const machineId = url.searchParams.get("machineId");

    if (machineId) {
      navigate(`/items?machineId=${machineId}&value=null&showItems=true`);
      CloseQrFun();
      setShowScanner(false);
    } else {
      toast.error("Machine ID Not Found", {
        position: "top-right",
        autoClose: 1000,
      });
    }
  } catch (error) {
    toast.error("Invalid QR Code", {
      position: "top-right",
      autoClose: 1000,
    });
  }
}

  };

  if (cameraError) {
    return (
      <div className="qr-modal-error">
        <p>No Camera Permission. Please reset your settings.</p>
      </div>
    );
  }



  return (
    <>
    {qrModelflag&&
      <div className="qr-modal-container">
      <HeaderSecondary/>
      {/* Webcam feed */}
      <Webcam
        audio={false}
        videoConstraints={videoConstraints}
        className="qr-modal-webcam"
      />

      {/* Blur overlay */}
      <div className="qr-modal-blur"></div>

      {/* QR Scanner */}
      {showScanner && (
        <div className="qr-modal-scanner">
          <QrReader
            delay={50}
            onError={handleError}
            onScan={handleScan}
            facingMode={cameraFacingMode}
            className="qr-reader"
          />
        </div>
      )}
    </div>}
    </>
  );
};

export default QRModal;
